import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type CancelExpenseClaimPayload = {
  claimId: string;
};

export const cancelExpenseClaim = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: CancelExpenseClaimPayload): Promise<string> => {
      return fetchWithAuth<string>("cancelExpenseClaim", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([
        ["awaitingExpenseClaims", dossierId],
        ["resolvedExpenseClaims"],
      ]),
  });
};
